import { render, staticRenderFns } from "./minute.vue?vue&type=template&id=72cdb382&scoped=true&"
import script from "./minute.vue?vue&type=script&lang=js&"
export * from "./minute.vue?vue&type=script&lang=js&"
import style0 from "./minute.vue?vue&type=style&index=0&id=72cdb382&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cdb382",
  null
  
)

export default component.exports